
import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import apiAuthCall from 'helpers/apiAuthCall';
import {
    actions,
    fetchEntityAuditLogsSuccess
} from './duck';
import {
    auditEntityEndpoint
} from './selectors';

export function* fetchEntityAuditLogs(api, action) {
    const notificationId = 'fetchEntityAuditLogs';
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(auditEntityEndpoint, action.payload),
            }
        );

        yield put(fetchEntityAuditLogsSuccess(result.data));
    } catch (err) {
        yield put(
            notify({
                id: notificationId,
                ...sagaError(err),
            })
        );
    }
}

export default function* auditsSagas({ api }) {
    yield all([
        takeLatest(actions.FETCH_ENTITY_AUDIT_LOGS, fetchEntityAuditLogs, api)
    ]);
}



// WEBPACK FOOTER //
// ./src/services/audits/saga.js